import { Box, Typography } from '@mui/material'
import React from 'react'

const TooltipTitle: React.FC<{ description: string | string[]; fontSize?: number }> = ({
  description,
  fontSize
}) => {
  const descriptions = description && Array.isArray(description) ? description : [description]

  return (
    <Box>
      {descriptions?.map((string, i) => (
        <Typography
          key={`${string}-${i}`}
          variant="body2"
          textAlign="center"
          fontSize={fontSize}
          color="textPrimary"
        >
          <React.Fragment>
            {string}
            {i !== descriptions.length - 1 && <br />}
          </React.Fragment>
        </Typography>
      ))}
    </Box>
  )
}

export default TooltipTitle
